import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'client-info',
    loadChildren: () =>
      import('./features/client-info/client-info.routes').then((m) => m.routes),
  },
  {
    path: 'tabs',
    loadChildren: () =>
      import('./features/tabs/tabs.routes').then((m) => m.routes),
  },
  {
    path: 'directory',
    loadChildren: () =>
      import('./features/directory/directory.routes').then((m) => m.routes),
  },
  {
    path: 'payment',
    loadChildren: () =>
      import('./features/payment/payment.routes').then((m) => m.routes),
  },
  {
    path: '',
    redirectTo: '/client-info',
    pathMatch: 'full',
  },
];
